export default __webpack_public_path__ + "388d36496972b619d75bb75b966dd116.png";